export default __webpack_public_path__ + "static/media/IMG_0428-2.50124499.jpg";